var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZeroPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    viewBox: "0 0 48 48",
    height: 36,
    width: 36,
    className: "createSvgIcon__Svg-sc-1l8xi8d-0 loXvaP ability-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22.203 4.557-.257.257v1.284l.513.513v6.163l-.641.642v2.054h-.77l-1.926-1.54v13.222c.128.514.59 1.669 1.412 2.182v-7.702l1.027-1.027v9.5L24 36.395l2.44-6.29v-9.5l1.026 1.027v7.702c.514-.342 1.54-1.258 1.54-2.182V13.929l-1.797 1.54h-.513v-2.053l-.77-.642V6.61l.513-.513V4.814l-.257-.257h-3.98Zm-.77 29.527 1.026 2.054-4.364-1.155 3.337-.898Zm4.108 1.926.898-1.925 3.081.898-3.98 1.027Zm-5.007-4.236.513 1.155-5.905.385-2.054 1.926 2.439 1.54 3.98 1.156 3.723.385h1.412l3.466-.642 4.622-.514 1.925-1.797c-.727-.599-2.208-1.797-2.31-1.797-.103 0-1.498-.428-2.183-.642l-3.338-.128.642-1.413 2.953.514 4.236.514 4.75 1.412L43 37.422l-3.338 3.723-9.885 1.798H17.709l-4.621-.9-4.365-1.283L5 37.422l3.466-3.337 4.622-1.798 7.446-.513Zm-7.19 1.669-2.053 1.925 3.85 2.44 3.98 1.026 3.98.642h1.67l3.337-.898 5.007-.257 3.338-2.953-2.311-1.925 4.621 1.283 2.568 2.568-2.31 2.824-9.63 1.798H18.48l-9.115-2.054-2.696-2.44 2.44-2.439 4.236-1.54Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroPoint);
export default __webpack_public_path__ + "static/media/zero-point.f8dfd17d.svg";
export { ForwardRef as ReactComponent };